import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Shield, Team, Bolt, Leaf, Headset } from '../components/Icons';
import './WhyChooseUs.css';

gsap.registerPlugin(ScrollTrigger);

const ITEMS = [
  { Icon: Shield,  title: 'Quality Assured',   desc: 'Top-tier equipment and industry best practices.' },
  { Icon: Team,    title: 'Experienced Team',  desc: 'Skilled specialists guiding every step.' },
  { Icon: Bolt,    title: 'High Performance',  desc: 'Built for maximum output and long-term reliability.' },
  { Icon: Leaf,    title: 'Sustainable Impact',desc: 'Cleaner energy for a cleaner planet.' },
  { Icon: Headset, title: 'Customer Focused',  desc: 'With you before, during, and after install.' },
];

export default function WhyChooseUs() {
  const sectionRef = useRef(null);
  const headRef    = useRef(null);
  const itemsRef   = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(headRef.current.children, {
        opacity: 0, y: 16, duration: 0.7, stagger: 0.1, ease: 'power3.out',
        scrollTrigger: { trigger: sectionRef.current, start: 'top 72%' },
      });
      gsap.from(itemsRef.current, {
        opacity: 0, y: 26, duration: 0.7, stagger: 0.08, ease: 'power3.out',
        scrollTrigger: { trigger: sectionRef.current, start: 'top 64%' },
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section className="section section--flow why-section" id="why" ref={sectionRef}>
      <div className="section-head" ref={headRef}>
        <p className="eyebrow">Why choose us</p>
        <h2 className="section-title">Built on trust.<br /><span className="accent">Driven by performance.</span></h2>
      </div>

      <div className="container why-grid">
        {ITEMS.map(({ Icon, title, desc }, i) => (
          <div className="why-item" key={i} ref={el => itemsRef.current[i] = el}>
            <span className="why-icon"><Icon width="24" height="24" /></span>
            <h3 className="why-title">{title}</h3>
            <p className="why-desc">{desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
